import { hooks } from '@wove/react';
import { BasicDomTarget, getTargetElement } from '../utils/dom-target';
import { useEffectCustom } from './use-effect-custom';

/**
 * document 事件处理
 * @param onEventCallback 事件回调
 * @param eventNames 事件名称数组
 * @param excludeTargets 排除的DOM节点或者Ref的数组
 * @example
 * ```
 * 可用于处理指定dom节点以外的document事件，例如点击任意位置执行回调
 * ```
 */
export const useDocumentEvent = <T extends Event = Event>(
  onEventCallback: (event: T) => void,
  eventNames: string[],
  excludeTargets?: BasicDomTarget[],
) => {
  const onEventCallbackRef = hooks.useCallbackRef(onEventCallback);

  const documentEventCallback = hooks.useCallbackRef((event) => {
    const targets = Array.isArray(excludeTargets) ? excludeTargets : [excludeTargets];
    const has = targets.some((item) => {
      const targetElement = getTargetElement(item);
      return !targetElement || targetElement?.contains(event.target);
    });
    if (has) return;
    onEventCallbackRef(event);
  });

  useEffectCustom(() => {
    document.addEventListener('click', documentEventCallback, false);
    return () => {
      document.removeEventListener('click', documentEventCallback, false);
    };
  }, [eventNames, excludeTargets]);
};
